<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg>
        <use href="assets/icons.svg#person"></use>
      </svg>
      Customer Details
    </h3>
  </div>

  <div class="card-content">
    <form class="customer-form" [formGroup]="customerForm">
      <div class="card-intro">
        <svg>
          <use href="assets/icons.svg#person"></use>
        </svg>
        <p>Enter customer details for the broadband application</p>
      </div>
      <div class="form-row">
        <div class="form-field">
          <label for="firstName" class="field-label">First Name *</label>
          <input
            type="text"
            class="form-input"
            name="firstName"
            placeholder="John"
            formControlName="firstName"
          />
        </div>

        <div class="form-field">
          <label for="lastName" class="field-label">Last Name *</label>
          <input
            type="text"
            class="form-input"
            name="lastName"
            placeholder="Doe"
            formControlName="lastName"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="email" class="field-label">Email Address *</label>
          <input
            type="email"
            id="email"
            class="form-input"
            name="email"
            placeholder="john@example.com"
            [class.invalid]="
              customerForm.controls.email.touched && customerForm.controls.email.invalid
            "
            formControlName="email"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="phone" class="field-label">Phone Number *</label>
          <input
            type="tel"
            class="form-input"
            name="phone"
            placeholder="+44 1234 567890"
            formControlName="phone"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="personalId" class="field-label">Personal ID Number *</label>
          <input
            type="text"
            class="form-input"
            name="personalId"
            placeholder="YYYYMMDD-XXXX"
            formControlName="personalId"
          />
        </div>
      </div>
    </form>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-secondary" type="button" (click)="goBack()">Back</button>
      <button
        type="submit"
        [disabled]="!customerForm.valid"
        class="btn btn-primary"
        (click)="sendOffer()"
      >
        Continue
      </button>
    </div>
  </div>
</div>
